import events from "./modules/events"
import forms from "./modules/forms";
import eventStatus from "./modules/participatorStatus";
import planning from "./modules/planning";
import stands from "./modules/stands";
import eventNps from "./modules/nps";
import eventBadge from "./modules/badge";
import notes from "./modules/notes";
import tickets from "./modules/tickets";
import sales from "./modules/sales";

export default {
    modules: {
        events,
        forms,
        eventStatus,
        planning,
        stands,
        eventNps,
        eventBadge,
        notes,
        tickets,
        sales
    }
}
